module.exports = __webpack_public_path__ + "img/red-x.4db8c76f.svg";